import { createStyles, withStyles, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme, WithStyles } from '@paintscout/ui'
import classnames from 'classnames'
import React from 'react'

export const styles = (theme: Theme) => {
  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start'
    },
    parenthesis: {
      ...theme.typography.button,
      paddingTop: theme.spacing(0.25),
      margin: `0 ${theme.spacing()}px`,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(10),
        margin: `0 ${theme.spacing(0.25)}px`,
        paddingTop: theme.spacing(0.33)
      }
    },
    strike: {
      position: 'relative',
      '&:before': {
        position: 'absolute',
        top: theme.typography.pxToRem(10),
        display: 'block',
        height: 2,
        content: '""',
        width: '100%',
        boxSizing: 'border-box',
        padding: `0 ${theme.spacing(0.5)}px`,
        background: theme.palette.common.black
      }
    }
  })
}

export interface CalculationTermProps extends WithStyles<typeof styles> {
  children?: React.ReactNode
  parenthesis?: boolean
  strike?: boolean
}

function CalculationTerm(props: CalculationTermProps) {
  const { children, parenthesis, strike, classes } = props

  const classNames = classnames({ [classes.root]: true, [classes.strike]: strike })

  if (parenthesis) {
    return (
      <div className={classNames}>
        <Typography variant={'overline'} classes={{ root: classes.parenthesis }}>
          (
        </Typography>
        {children}
        <Typography variant={'overline'} classes={{ root: classes.parenthesis }}>
          )
        </Typography>
      </div>
    )
  }

  return <div className={classNames}>{children}</div>
}

export default withStyles(styles)(CalculationTerm)
